module.exports = function() {
  return new Worker(__webpack_public_path__ + "e38fee4559fd28b57f38.worker.js");
};